var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 10.0418L17.5 14.1668L13.375 18.2918L12.1967 17.1135L14.31 14.9993L3.33333 15.0002V13.3335H14.31L12.1967 11.2202L13.375 10.0418ZM6.625 1.7085L7.80333 2.88683L5.69 5.00016H16.6667V6.66683H5.69L7.80333 8.78016L6.625 9.9585L2.5 5.8335L6.625 1.7085Z",
    fill: "#232428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.f826e8f5e9b016be579774a42235d8f1.svg";
export { ForwardRef as ReactComponent };